<button
  title="Toggle dark mode"
  (click)="toggleTheme()"
  aria-label="Toggle dark mode"
  class="theme-icon-container"
  [aria-pressed]="isDarkMode()"
>
  @if (isDarkMode()) {
    <mat-icon class="theme-icon">dark_mode</mat-icon>
  } @else {
    <mat-icon class="theme-icon">light_mode</mat-icon>
  }
</button>
